import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "construction-workers" }
const _hoisted_2 = { class: "construction-workers" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Bekijken", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Bewerken", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Toegang herstellen", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze medewerker weer toegang wilt geven?", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Toegang weigeren", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze medewerker wilt weigeren?", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze persoon de toegang wilt ontzeggen?", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Deze persoon kan daarna niet meer werken op een bouwplaats van Thunnissen en collega uitvoerders krijgen een melding wanneer ze deze persoon willen registreren.", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Naam", -1)
const _hoisted_13 = { class: "no-mb" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Geboortedatum", -1)
const _hoisted_15 = { class: "no-mb" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Reden van weigeren", -1)

import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { ls } from '@/ls'
import Column from '@/types/column'
import TableSettings from '@/types/tableSettings'
import axios from 'axios'
import { constructionWorkerStore } from '@/stores/constructionWorker'
import { EyeOutlined, HighlightOutlined, StopOutlined, CheckOutlined } from '@ant-design/icons-vue'
import { authStore } from '@/stores/auth'
import PageTitleBar from '@/components/PageTitleBar.vue'
import FilterBox from '@/components/FilterBox.vue'
import { notification } from 'ant-design-vue'
import { can } from '@/globalFunctions'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConstructionWorkers',
  setup(__props) {

const router = useRouter()
const denyAccess = ref<{ constructionWorkerId:number|null, name: string|null, date_of_birth: string|null, reason: string|null }>({
  constructionWorkerId: null,
  name: null,
  date_of_birth: null,
  reason: null
})
const denyAccessModalVisible = ref(false)
const saving = ref(false)

const columns = ref([
  {
    title: 'Medewerker',
    key: 'firstname',
    sorter: true
  },
  {
    title: 'Bedrijf',
    key: 'company.id',
    filters: authStore().isInternal ? [] : false,
    sorter: true
  },
  {
    title: 'In dienst',
    key: 'active',
    filters: [
      {
        text: 'Ja',
        value: 1
      },
      {
        text: 'Nee',
        value: 0
      }
    ],
    sorter: false
  },
  {
    title: 'Geweigerd',
    key: 'denied',
    filters: [
      {
        text: 'Ja',
        value: 1
      },
      {
        text: 'Nee',
        value: 0
      }
    ],
    sorter: true
  },
  {
    title: 'Actie\'s',
    key: 'actions'
  }
])

const columnsWithoutCompany = ref([
  {
    title: 'Medewerker',
    key: 'firstname',
    sorter: true
  },
  {
    title: 'In dienst',
    key: 'active',
    filters: [
      {
        text: 'Ja',
        value: 1
      },
      {
        text: 'Nee',
        value: 0
      }
    ],
    sorter: false
  },
  {
    title: 'Actie\'s',
    key: 'actions'
  }
])

const tableSettings = ref<TableSettings>(ls.get('constructionWorkerTableSettings') || {
  pagination: { current: 1, pageSize: 25 },
  showSizeChanger: true,
  pageSizeOptions: ['25', '50', '100'],
  activeFilters: null,
  sort: null,
  search: null
})

onMounted(() => {
  constructionWorkerStore().getConstructionWorkers(tableSettings.value, true)
  getFilters()
  onTableSettingsChange()
})

watch(() => tableSettings, () => {
  onTableSettingsChange()
}, { deep: true })

function handleTableChange (pagination:{ current:number, pageSize:number }, filters:{[key: string]: number[]|string[]}, sort:{ columnKey:string, order:string }) : void {
  // Remove key from filters if filter is an empty object.
  if (filters && Object.keys(filters).length) {
    Object.keys(filters).forEach((key) => {
      if (!filters[key] || !filters[key].length) {
        delete filters[key]

        columns.value.forEach((column:Column) => {
          if (column.key === key) {
            column.filteredValue = null
          }
        })
      }
    })
  }

  // Set pagination, filters and sorting on tableSettings.
  tableSettings.value.pagination = pagination
  tableSettings.value.activeFilters = filters
  tableSettings.value.sort = sort.order ? sort : null

  // Get list based on filters and search term.
  constructionWorkerStore().getConstructionWorkers(tableSettings.value, true)
}

function handleSearchChange (searchTerm:string) : void {
  tableSettings.value.search = searchTerm

  // Set page to 1 because of new search but retain filters and sorting.
  tableSettings.value.pagination.current = 1

  // Get list based on filters and search term.
  constructionWorkerStore().getConstructionWorkers(tableSettings.value, true)
}

function onTableSettingsChange () : void {
  // On tableSettings change, store them in local storage.
  ls.set('constructionWorkerTableSettings', tableSettings.value)

  axios.post(process.env.VUE_APP_API_URL + '/users/constructionSiteApp/settings', {
    settingName: 'constructionWorkerTableSettings',
    settingValue: tableSettings.value
  })

  // Set the current active filters on the columns.
  columns.value.forEach((column:Column) => {
    // Set active filters.
    if (tableSettings.value.activeFilters && column.key in tableSettings.value.activeFilters) {
      column.filteredValue = tableSettings.value.activeFilters[column.key]
    } else {
      column.filteredValue = null
    }

    // Set active sort order.
    if (tableSettings.value.sort && column.key === tableSettings.value.sort.columnKey) {
      column.defaultSortOrder = tableSettings.value.sort.order
      column.sortOrder = tableSettings.value.sort.order
    } else {
      column.sortOrder = false
    }
  })
}

function getFilters () : void {
  if (authStore().isInternal) {
    getCompanyFilter()
  }
}

function getCompanyFilter () : void {
  axios.post(process.env.VUE_APP_API_URL + '/filters/company/construction_workers', { textColumn: 'name', valueColumn: 'id' }).then((res) => {
    columns.value[1].filters = res.data
  })
}

function updateFilters (activeFilters:{[key: string]: number[]|string[]}) : void {
  tableSettings.value.activeFilters = activeFilters
  constructionWorkerStore().getConstructionWorkers(tableSettings.value, true)
}

function onRowClick (rowData:{ id:number }) : { on: { click: () => void }} {
  return {
    on: {
      click: () => {
        const keyboard = window.event as KeyboardEvent
        if (can('construction_workers.edit')) {
          const route = router.resolve({ name: 'ConstructionWorkerEdit', params: { constructionWorkerId: rowData.id.toString() } })
          window.open(route.href, keyboard.ctrlKey ? '_blank' : '_self')
        } else if (can('construction_workers.view')) {
          const route = router.resolve({ name: 'ConstructionWorkerShow', params: { constructionWorkerId: rowData.id.toString() } })
          window.open(route.href, keyboard.ctrlKey ? '_blank' : '_self')
        }
      }
    }
  }
}

const itemList = computed(() => {
  return constructionWorkerStore().constructionWorkersList
})

const pagination = computed(() => {
  return {
    current: tableSettings.value.pagination.current,
    defaultPageSize: tableSettings.value.pagination.pageSize,
    pageSize: parseInt(itemList.value.meta.per_page),
    total: itemList.value.meta.total,
    showTotal: (total:number, range:number[]) => `Bouwplaatsmedewerker ${range[0]} t/m ${range[1]} van de ${total}`,
    showSizeChanger: tableSettings.value.showSizeChanger,
    pageSizeOptions: tableSettings.value.pageSizeOptions
  }
})

const loading = computed(() => {
  return constructionWorkerStore().loading.list
})

function allowConstructionWorker (id:number) : void {
  saving.value = true
  axios.post(process.env.VUE_APP_API_URL + '/constructionWorkers/' + id + '/allow')
    .then(() => {
      notification.success({
        message: 'Toegang succesvol hersteld.',
        description: 'De bouwplaatsmedewerker kan weer geregistreerd worden op een van onze bouwplaatsen.',
        duration: 5
      })
      constructionWorkerStore().getConstructionWorkers(tableSettings.value, true)
    }).catch(() => {
      notification.error({
        message: 'Fout tijdens herstellen van toegang!',
        description: 'Er is iets mis gegaan. Probeer het later nog een keer.'
      })
    })
}

function denyConstructionWorker (workerId:number) : void {
  hideDenyAccessModal()
  saving.value = true
  axios.post(process.env.VUE_APP_API_URL + '/constructionWorkers/' + workerId + '/deny', { reason: denyAccess.value.reason })
    .then(() => {
      notification.success({
        message: 'Toegang succesvol ontzegd.',
        description: 'De bouwplaatsmedewerker kan niet langer geregistreerd worden op een van onze bouwplaatsen.',
        duration: 5
      })
      constructionWorkerStore().getConstructionWorkers(tableSettings.value, true)
    }).catch((res) => {
      notification.error({
        message: 'Fout tijdens weigeren van bouwplaatsmedewerker!',
        description: 'Er is iets mis gegaan. Probeer het later nog een keer.'
      })
    }).finally(() => {
      saving.value = false
    })
}

function hideDenyAccessModal () : void {
  denyAccessModalVisible.value = false
  denyAccess.value = { constructionWorkerId: null, name: null, date_of_birth: null, reason: null }
}
const modalData = ref<{ constructionWorkerId:number|null, name: string|null, date_of_birth: string|null, reason: string|null }>({
  constructionWorkerId: null,
  name: null,
  date_of_birth: null,
  reason: null
})
function showDenyAccessModal (constructionWorker:{ id:number, firstname:string, lastname:string, date_of_birth:string }) : void {
  modalData.value = constructionWorker
  denyAccess.value = {
    constructionWorkerId: constructionWorker.id,
    name: `${constructionWorker.firstname} ${constructionWorker.lastname}`,
    date_of_birth: new Date(constructionWorker.date_of_birth).toLocaleDateString('nl-NL'),
    reason: null
  }
  denyAccessModalVisible.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PageTitleBar, null, {
        title: _withCtx(() => [
          _createTextVNode("Medewerkers.")
        ]),
        buttons: _withCtx(() => [
          _createVNode(_component_a_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'ConstructionWorkerCreate' })))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Medewerker toevoegen")
            ]),
            _: 1
          })
        ]),
        search: _withCtx(() => [
          _createVNode(_component_a_input_search, {
            placeholder: "Zoeken..",
            style: {"width":"100%"},
            value: tableSettings.value.search,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((tableSettings.value.search) = $event)),
            onSearch: handleSearchChange,
            "enter-button": "",
            "allow-clear": ""
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(FilterBox, {
          view: "construction-workers",
          "active-filters": tableSettings.value.activeFilters,
          columns: columns.value,
          onUpdate: updateFilters
        }, null, 8, ["active-filters", "columns"]),
        _createVNode(_component_a_table, {
          columns: _unref(authStore)().isInternal ? columns.value : columnsWithoutCompany.value,
          "data-source": _unref(itemList).data,
          loading: _unref(loading),
          rowKey: "id",
          customRow: onRowClick,
          pagination: _unref(pagination),
          onChange: handleTableChange
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'firstname')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(record.full_name), 1),
                  _hoisted_3,
                  _createTextVNode(_toDisplayString(new Date(record.date_of_birth).toLocaleDateString('nl-NL')), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'company.id')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(record.company ? record.company.name : '-'), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'active')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(record.active ? 'Ja' : 'Nee'), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'denied')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createTextVNode(_toDisplayString(record.denied.is_denied ? 'Ja' : 'Nee'), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'actions')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createVNode(_component_a_tooltip, { placement: "top" }, {
                    title: _withCtx(() => [
                      _hoisted_4
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        class: "listview-action",
                        size: "small",
                        onClick: _withModifiers(($event: any) => (_unref(router).push({ name: 'ConstructionWorkerShow', params: { constructionWorkerId: record.id } })), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(EyeOutlined))
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  (_unref(can)('construction_workers.edit'))
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "top"
                      }, {
                        title: _withCtx(() => [
                          _hoisted_5
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            class: "listview-action",
                            size: "small",
                            onClick: _withModifiers(($event: any) => (_unref(router).push({ name: 'ConstructionWorkerEdit', params: { constructionWorkerId: record.id } })), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(HighlightOutlined))
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (_unref(can)('companies.users.edit') && record.denied.is_denied)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 1,
                        placement: "top"
                      }, {
                        title: _withCtx(() => [
                          _hoisted_6
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_popconfirm, {
                            placement: "topRight",
                            "ok-text": "Ja",
                            "cancel-text": "Nee",
                            onConfirm: ($event: any) => (allowConstructionWorker(record.id))
                          }, {
                            title: _withCtx(() => [
                              _hoisted_7
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                class: "listview-action",
                                size: "small",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(CheckOutlined))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (_unref(can)('companies.users.edit') && !record.denied.is_denied)
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 2,
                        placement: "top"
                      }, {
                        title: _withCtx(() => [
                          _hoisted_8
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_popconfirm, {
                            placement: "topRight",
                            "ok-text": "Ja",
                            "cancel-text": "Nee",
                            onConfirm: ($event: any) => (showDenyAccessModal(record))
                          }, {
                            title: _withCtx(() => [
                              _hoisted_9
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                class: "listview-action",
                                size: "small",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(StopOutlined))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source", "loading", "pagination"])
      ])
    ]),
    _createVNode(_component_a_modal, {
      title: "Toegang tot bouwplaats ontzeggen.",
      "ok-text": "Ja, toegang ontzeggen",
      "ok-button-props": { disabled: !denyAccess.value.reason || saving.value, loading: saving.value },
      visible: denyAccessModalVisible.value,
      onCancel: hideDenyAccessModal,
      onOk: _cache[5] || (_cache[5] = ($event: any) => (denyConstructionWorker(denyAccess.value.constructionWorkerId)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          gutter: [16,16],
          class: "no-mb"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_10,
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createElementVNode("p", _hoisted_13, _toDisplayString(denyAccess.value.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_14,
                _createElementVNode("p", _hoisted_15, _toDisplayString(denyAccess.value.date_of_birth), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_16,
                _createVNode(_component_a_textarea, {
                  value: denyAccess.value.reason,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((denyAccess.value.reason) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["ok-button-props", "visible"])
  ], 64))
}
}

})